import { Injectable, inject } from '@angular/core';
import { ImageEditorModalComponent } from '@web/shared/modals/image-editor-modal/image-editor-modal.component';
import { BsModalService } from 'ngx-bootstrap/modal';
import { type SelectedFileExtended } from '@common/types/file.type';
import { type SelectedFileInterface } from '@sendpulse/file-manager';
import { SiteFacade } from '@web/store/website/site/site.facade';
import { type Widget } from '@common/types/content.type';
import { type WidgetDataSubTypes, WidgetsDataTypes } from '@common/enums';
import { type NormalizedBlockEntity, type NormalizedColumnEntity } from '@web/types';

import { backgroundImageOf } from '@web/core/services/entity-background-image';

@Injectable({
    providedIn: 'root',
})
export class ImageEditorService {
    protected readonly modalService = inject(BsModalService);
    protected readonly siteFacade = inject(SiteFacade);

    public showEditImageModal(file: SelectedFileExtended, widget: Widget, dataType: WidgetsDataTypes, index?: number) {
        const modalRef = this.modalService.show(ImageEditorModalComponent, {
            class: 'custom-modal',
            initialState: {
                image: file,
            },
        });

        modalRef.content.onClose.subscribe((image) => {
            if (!image) return;

            this.siteFacade.uploadImage({
                image,
                folder: this.preparedFolderPath(file),
                widgetId: widget.id,
                widgetImage:
                    dataType === WidgetsDataTypes.images ? widget.data[dataType][index] : widget.data[dataType],
                dataType,
                index,
            });
        });
    }

    public showEditBackgroundImageModal(
        file: SelectedFileExtended,
        entity: NormalizedBlockEntity | NormalizedColumnEntity,
        dataSubType: WidgetDataSubTypes,
        device: 'desktop' | 'tablet' | 'mobile' = 'desktop'
    ) {
        const modalRef = this.modalService.show(ImageEditorModalComponent, {
            class: 'custom-modal',
            initialState: {
                image: file,
            },
        });

        modalRef.content.onClose.subscribe((image) => {
            if (!image) return;

            this.siteFacade.uploadImage({
                image,
                folder: this.preparedFolderPath(file),
                entityId: entity.id,
                entityImage: backgroundImageOf(entity, device),
                dataType: WidgetsDataTypes.backgroundImage,
                dataSubType,
                device,
            });
        });
    }

    private preparedFolderPath(image: SelectedFileExtended): string {
        const path = image.path.split('/');
        path.shift();
        if (path.length === 1) return '/';

        path.pop();

        return `/${path.join('/')}/`;
    }
}
